<p-button
    (click)="op.toggle($event)"
    [outlined]="true"
    [icon]="op.overlayVisible ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
    iconPos="right"
    styleClass="w-full flex gap-2"
>
    <div class="flex gap-2">
        <span class="block overflow-hidden max-w-10rem text-overflow-ellipsis white-space-nowrap">{{
            selectedTask.name | translate
        }}</span>
    </div>
</p-button>

<p-overlayPanel #op styleClass="shadow-md" (onHide)="savedList.hide()">
    <ng-template pTemplate="content">
        <div class="p-3 surface-border border-bottom-1">
            <p class="text-lg font-semibold text-xl mb-3">{{ 'default-cm-inboxList' | translate: 'Inbox List' }}</p>
            <span class="p-input-icon-left w-full h-min">
                <input
                    type="text"
                    pInputText
                    class="p-inputtext-sm w-full"
                    placeholder="{{ 'default-cm-search' | translate: 'Search' }}"
                    [(ngModel)]="searchInput"
                    (input)="updateFilteredFilters()"
                />
                <i class="pi pi-search"></i>
            </span>
        </div>
        @if (taskConfigs | inboxSearch: searchInput; as filteredTaskConfigs) {
            <div class="w-22rem max-h-24rem overflow-auto">
                @if (adminFilterFeatureEnabled) {
                    @if (adminFilters | inboxSearch: searchInput; as filteredAdminFilter) {
                        @if (filteredAdminFilter.length) {
                            <div class="py-3" id="adminFilter">
                                <p class="px-3 text-md text-primary-500 text-base font-normal">
                                    {{ 'default-cm-customList' | translate: 'Custom List' }}
                                </p>
                                @for (filter of filteredAdminFilter; track $index) {
                                    <div
                                        class="px-3 flex justify-content-between align-items-center hover:surface-hover cursor-pointer"
                                        (click)="handleAdminFilter(filter, $index, op)"
                                    >
                                        <span
                                            [pTooltip]="filter.name"
                                            tooltipPosition="bottom"
                                            class="font-medium block overflow-hidden max-w-10rem text-overflow-ellipsis white-space-nowrap"
                                            [ngClass]="{ 'text-primary-700': filter.name === selectedTask.name }"
                                            >{{ filter.name }}
                                        </span>
                                        <div class="flex justify-content-center align-items-center">
                                            <div class="flex flex-wrap gap-2">
                                                <p-tag
                                                    [style]="{ background: '#EAF0FB', color: '#193F80' }"
                                                    [rounded]="true"
                                                    styleClass="radius-2xl padding-py-1"
                                                >
                                                    <div
                                                        class="flex align-items-center padding-px-4 justify-content-center text-sm gap-1"
                                                    >
                                                        <span class="text-xsmall text-primary-700 text-bold">{{
                                                            selectedTaskNames[filter.key] | translate
                                                        }}</span>
                                                    </div>
                                                </p-tag>
                                                @if (
                                                    filter.name === defaultTaskName && filter['type'] === 'ADMIN_FILTER'
                                                ) {
                                                    <span
                                                        class="flex align-items-center bg-primary-400 border-round-2xl px-2"
                                                    >
                                                        <img src="assets/icons/default-dot.svg" alt="Default" />
                                                        <span class="text-sm text-primary-700 font-medium px-1">
                                                            {{ 'default-cm-default' | translate: 'Default' }}
                                                        </span>
                                                    </span>
                                                }
                                            </div>
                                            <p-button
                                                styleClass="h-3rem bg-white-alpha-10 border-none p-0 text-color-secondary hover:text-primary-700"
                                                icon="pi pi-ellipsis-v"
                                                [outlined]="true"
                                                appendTo="body"
                                                tooltipPosition="bottom"
                                                (click)="
                                                    makeSavedListMenu(
                                                        filter,
                                                        savedList,
                                                        $event,
                                                        $index,
                                                        defaultListMenu
                                                    )
                                                "
                                            ></p-button>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    }
                }
                @if (filteredTaskConfigs.length) {
                    <div class="py-3 surface-border border-bottom-1">
                        <p class="text-md px-3 font-normal text-base mb-2 text-primary-500">
                            {{ 'default-cm-defaultList' | translate: 'Default List' }}
                        </p>
                        @for (task of filteredTaskConfigs; track $index) {
                            <div
                                class="px-3 flex justify-content-between align-items-center cursor-pointer hover:surface-hover"
                            >
                                @if (inboxtask[task.key]?.enabled) {
                                    <span
                                        class="cursor-pointer font-medium w-full"
                                        [ngClass]="{ 'text-primary-700': task.name === selectedTask.name }"
                                        (click)="handleTask(task, $index, op)"
                                        >{{ task.name | translate }}
                                    </span>
                                    <div class="flex justify-content-center align-items-center">
                                        <span [hidden]="!task.default">
                                            <span class="flex align-items-center bg-primary-400 border-round-2xl px-2">
                                                <svg
                                                    width="8"
                                                    height="8"
                                                    viewBox="0 0 8 8"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <rect
                                                        x="4"
                                                        y="-0.199219"
                                                        width="6"
                                                        height="6"
                                                        rx="1"
                                                        transform="rotate(45 4 -0.199219)"
                                                        fill="#265EBE"
                                                    />
                                                </svg>
                                                <span class="text-sm text-primary-700 font-medium px-1">
                                                    {{ 'default-cm-default' | translate: 'Default' }}
                                                </span>
                                            </span>
                                        </span>
                                        <p-button
                                            styleClass="h-3rem bg-white-alpha-10 border-none p-0 text-color-secondary hover:text-primary-700"
                                            icon="pi pi-ellipsis-v"
                                            [outlined]="true"
                                            appendTo="body"
                                            tooltipPosition="bottom"
                                            (click)="
                                                makeDefaultListMenu(task, $event, $index, defaultListMenu, savedList)
                                            "
                                        ></p-button>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
                @if (savedLists | inboxSearch: searchInput; as filteredSavedTasks) {
                    @if (filteredSavedTasks.length) {
                        <div class="py-3">
                            <p class="px-3 text-md text-primary-500 text-base font-normal">
                                {{ 'default-cm-savedList' | translate: 'Saved Lists' }}
                            </p>
                            @for (filter of filteredSavedTasks; track $index) {
                                <div
                                    class="px-3 flex justify-content-between align-items-center hover:surface-hover cursor-pointer"
                                    (click)="handleTask(filter, $index, op)"
                                >
                                    <span
                                        [pTooltip]="filter.name"
                                        tooltipPosition="bottom"
                                        class="font-medium block overflow-hidden text-overflow-ellipsis white-space-nowrap flex-shrink-1 min-w-0"
                                        style="max-width: 150px"
                                        [ngClass]="{ 'text-primary-700': filter.name === selectedTask.name }"
                                        >{{ filter.name }}
                                    </span>
                                    <div class="flex align-items-center gap-2 flex-shrink-0">
                                        <div class="flex gap-2 align-items-center flex-shrink-0">
                                            <p-tag
                                                [style]="{ background: '#EAF0FB', color: '#193F80' }"
                                                [rounded]="true"
                                                styleClass="radius-2xl padding-py-1"
                                            >
                                                <div
                                                    class="flex align-items-center padding-px-4 justify-content-center text-sm gap-1"
                                                >
                                                    <span class="text-xsmall text-primary-700 text-bold">{{
                                                        selectedTaskNames[filter.key] | translate
                                                    }}</span>
                                                </div>
                                            </p-tag>
                                            @if (filter?.default) {
                                                <span
                                                    class="flex align-items-center bg-primary-400 border-round-2xl px-2"
                                                >
                                                    <img src="assets/icons/default-dot.svg" alt="Default" />
                                                    <span class="text-sm text-primary-700 font-medium px-1">
                                                        {{ 'default-cm-default' | translate: 'Default' }}
                                                    </span>
                                                </span>
                                            }
                                        </div>
                                        <p-button
                                            styleClass="h-3rem bg-white-alpha-10 border-none p-0 text-color-secondary hover:text-primary-700"
                                            icon="pi pi-ellipsis-v"
                                            [outlined]="true"
                                            appendTo="body"
                                            tooltipPosition="bottom"
                                            (click)="
                                                makeSavedListMenu(filter, savedList, $event, $index, defaultListMenu)
                                            "
                                        ></p-button>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    @if (
                        !filteredTaskConfigs.length &&
                        !filteredSavedTasks.length &&
                        (!adminFilterFeatureEnabled || !(adminFilters | inboxSearch: searchInput)?.length)
                    ) {
                        <div class="flex justify-content-center p-3">
                            <div>
                                <img src="assets/icons/no-result-found.svg" alt="" />
                            </div>
                        </div>
                    }
                }
            </div>
        }
    </ng-template>
</p-overlayPanel>
<p-menu #savedList [model]="savedListMenu" [popup]="true">
    <ng-template pTemplate="item" let-action>
        <div class="flex w-full cursor-pointer">
            <span
                class="flex align-items-center p-2 w-full"
                (click)="savedListMenuClick($event, action, op, savedList)"
                [ngClass]="{ 'text-red-500': action.label === 'default-cm-delete' }"
                >{{ action.label | translate }}</span
            >
        </div>
    </ng-template>
</p-menu>
<p-menu
    #defaultListMenu
    [model]="kababMenu"
    [popup]="true"
    [appendTo]="'body'"
    styleClass="w-max border-1 bg-white border-round-sm surface-border p-0"
>
    <ng-template pTemplate="item" let-action>
        <div class="cursor-pointer border-bottom-1 border-50 bg-white-alpha-10">
            <span
                class="flex align-items-center p-2 hover:surface-hover bg-white-alpha-10"
                (click)="setDefaultTask(action.task, action.index, op)"
                >{{ action.label | translate }}</span
            >
        </div>
    </ng-template>
</p-menu>
